// Types
import type { Action } from "./types";

/**
 * Super admin Available Credit Memo screen: the credit memos waiting for
 * action across every business, and the steps that take one from detected to
 * paid out.
 */

export type CreditMemoListFilter = "open" | "closed" | "all";

export type CreditMemoAction =
  | "approve"
  | "taxTransferDone"
  | "confirmBank"
  | "moneySent"
  | "cancel"
  | "void"
  | "sendPayout"
  | "retryPayout"
  | "resolvePayout";

/**
 * @param {CreditMemoListFilter} filter
 * @return {*} {Action}
 */
export const fetchCreditMemos = (filter: CreditMemoListFilter): Action => ({
  type: "FETCH_CREDIT_MEMOS",
  data: filter,
});

/**
 * Reads one credit memo with its transactions. With `balanceCheck` the service
 * also compares Aya with DC Bank for the whole business.
 *
 * @param {*} data
 * @return {*} {Action}
 */
export const fetchCreditMemo = (data: {
  businessGuid: string;
  creditMemoGuid: string;
  balanceCheck?: boolean;
}): Action => ({
  type: "FETCH_CREDIT_MEMO",
  data,
});

/**
 * Runs one step on a credit memo. `payload` carries what the step needs: the
 * bank account for confirmBank, the reference for moneySent, the reason for
 * cancel.
 *
 * @param {*} data
 * @return {*} {Action}
 */
export const runCreditMemoAction = (data: {
  businessGuid: string;
  creditMemoGuid: string;
  action: CreditMemoAction;
  payload?: any;
  filter: CreditMemoListFilter;
}): Action => ({
  type: "RUN_CREDIT_MEMO_ACTION",
  data,
});

export type CreditMemoExportFormat = "pdf" | "xlsx";

/**
 * Saves a credit memo as the PDF sent to the client (a draft for a memo not
 * approved yet) or as an Excel file laid out like it.
 *
 * @param {*} data
 * @return {*} {Action}
 */
export const exportCreditMemo = (data: {
  businessGuid: string;
  creditMemoGuid: string;
  format: CreditMemoExportFormat;
}): Action => ({
  type: "EXPORT_CREDIT_MEMO",
  data,
});

/**
 * @param {*} data
 * @return {*} {Action}
 */
export const setCreditMemos = (data: any): Action => ({
  type: "SET_CREDIT_MEMOS",
  data,
});

/**
 * Closes the "balance not matching" pop-up.
 *
 * @return {*} {Action}
 */
export const clearCreditMemoRefusal = (): Action => ({
  type: "CLEAR_CREDIT_MEMO_REFUSAL",
});
